const editData = (cms, tabData) => {
  const { isAttachmentVisible, isMetafield, isVariant, isCampaign } = tabData || {};
  const filterTab = [
    {
      id: "information",
      content: cms("label.information"),
      panelID: "information-content",
    },
  ];
  if (!isVariant || isCampaign) {
    filterTab.push({
      id: "inventory",
      content: cms("label.inventory"),
      panelID: "inventory-content",
    });
  }
  filterTab.push(
    {
      id: "image",
      content: cms("label.image"),
      panelID: "image-content",
    },
    {
      id: "variant",
      content: cms("label.variant"),
      panelID: "variant-content",
    }
  );
  if (!isVariant) {
    filterTab.push({
      id: "fulfillment",
      content: cms("label.fulfillment"),
      panelID: "fulfillment-content",
    });
  }
  if (isMetafield) {
    filterTab.push({
      id: "metafield",
      content: cms("label.metafieldPlural"),
      panelID: "metafield-content",
    });
  }
  if (isAttachmentVisible) {
    filterTab.push({
      id: "attachment",
      content: cms("label.attachment"),
      panelID: "attachment-content",
    });
  }

  return {
    option: {
      option1: "option1",
      option2: "option2",
      option3: "option3",
    },
    policyOption: [
      {
        label: cms("label.notTrack"),
        value: "Don't track inventory",
      },
      {
        label: cms("label.shopify"),
        value: "shopify",
      },
    ],
    tabs: filterTab,
  };
};

export default editData;
